export class TicketOrderId {
  object = 'ticketOrderId';
  ticketOrderId: number;
}
